const groupSubservices = (subservices = []) => {
  if (!Array.isArray(subservices)) return [];

  return Array.from(
    subservices
      .reduce((groups, subservice) => {
        const group = groups.get(subservice.parentId);

        if (group) {
          group.options.push(subservice);
        } else {
          groups.set(subservice.parentId, {
            id: subservice.parentId,
            name: subservice.parentName,
            options: [subservice],
          });
        }

        return groups;
      }, new Map())
      .values()
  );
};

export default groupSubservices;
